export var monthNamesNo = [
    'ERROR - ZERO INDEXED LOOKUP',
    'januar',
    'februar',
    'mars',
    'april',
    'mai',
    'juni',
    'juli',
    'august',
    'september',
    'oktober',
    'november',
    'desember',
];
export var monthNamesEn = [
    'ERROR - ZERO INDEXED LOOKUP',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
export var monthNames = {
    no: monthNamesNo,
    en: monthNamesEn,
};
